import React, { useEffect } from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import SectionMessage from '@atlaskit/section-message/message';
import { Text } from '@atlaskit/primitives/compiled';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { trackEmbeddedMacroRejected } from '../../analytics';

const messages = defineMessages({
	title: {
		id: 'forge.ui.extension.not.installed.title',
		defaultMessage: 'App not available',
		description: 'Title shown when a Forge extension/macro is not installed on the tenant',
	},
	message: {
		id: 'forge.ui.extension.not.installed.message',
		defaultMessage:
			"We can't display this content because the app isn't installed. Contact your administrator to install it.",
		description: 'Message shown when a Forge extension/macro is not installed on the tenant',
	},
});

type ExtensionNotInstalledProps = {
	extensionId: string;
};

export const ExtensionNotInstalled = ({
	extensionId,
}: ExtensionNotInstalledProps): React.JSX.Element => {
	const intl = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		trackEmbeddedMacroRejected(createAnalyticsEvent, {
			source: 'forgeUIRenderer',
			extensionId,
			reason: 'not_installed',
		});
	}, [createAnalyticsEvent, extensionId]);

	return (
		<SectionMessage
			title={intl.formatMessage(messages.title)}
			appearance="warning"
			testId="extension-not-installed"
		>
			<Text as="p">
				<FormattedMessage {...messages.message} />
			</Text>
		</SectionMessage>
	);
};
